export default __webpack_public_path__ + "static/N0310-9a4f8fe668509e0dd682dbd20d628e42.png";